import { gql } from '@apollo/client';

export const RemoveLapMutation = gql`
    mutation RemoveLap($id: ID!) {
        removeLap(id: $id)
    }
`;
